<template>
<!--案例页客户评论轮播图-->
  <div class="case-swiper-box">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for = "(item) in customComment ">
          <div class="logo">
            <img :src= "'http://www.jxdinfo.com'+item.typeImg">
          </div>
          <div class="staff">{{item.title}}</div>
          <div class="desc">
            <span>{{ item.description }}</span>
          </div>
          <img src="../assets/img/casePage/customback.png" class="back">
        </div>
      </div>
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>

import {Navigation, Pagination, Swiper} from "swiper";
import {getCustomComment} from "../api/casePage";
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'
Swiper.use([Navigation,Pagination]);
export default {
  name: "CustomCommentSwiper",
  props: {
  },
  data() {
    return {
      customComment:[],
      customCommentData:{
        channelId:289,
      }
    };
  },
  setup() {
    return {
      modules: [Pagination],
    };
  },
  methods:{
    async getCustomComment(){
      const self = this;
      await getCustomComment(self.customCommentData).then((res) =>{
        res.data.content.reverse();
        self.customComment = res.data.content;
        for (let i = 0; i < self.customComment.length; i++) {
          self.customComment[i].title = self.customComment[i].title.replace('*',' ')
        }
        setTimeout(()=>{
          self.initSwiper();
        },100)
      }).catch((error) => {
        self.$message.error('未获取到客户评论信息!');
      });
    },
    initSwiper() {
      const self = this;
      var mySwiper = new Swiper ('.swiper-container', {
        slidesPerView: 3,
        spaceBetween: 25,
        loopFillGroupWithBlank: true,
        slidesPerGroup: 3,
        // centeredSlides: true,
        //loop: true, // 循环模式选项
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          observer: true,//开启动态检查器，监测swiper和slide
          observeParents: true//监测Swiper 的祖/父元素
        },
        on: {
          //当切换时触发的方法
          slideChange: function(e) {
            self.$emit('changeBg', e.activeIndex % 6);
          }
        }
      });
    }
  },

  mounted() {
    const self = this;
    self.getCustomComment();
  },
}
</script>

<style scoped>
.case-swiper-box {width: 1115px;position: relative;margin: 0px auto;padding-top: 80px;padding-bottom: 20px}
.swiper-container {overflow: hidden;}
.swiper-wrapper {width: 100%;height: 100%;}
.swiper-slide {
  position: relative;
  width: 330px;
  font-size: 18px;
  height: 350px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 15px 1px rgba(0,65,178,0.1);
}
.swiper-slide .logo {position: relative;margin: 30px auto 20px 35px;transform: scale(1);left: 0;height: 55px;}
.swiper-slide .back{bottom: 0;right: 0;position: absolute;}
.swiper-slide .logo img {}
.staff {margin: 12px auto 20px 35px;font-size: 16px;font-weight: bold;line-height: 22px;}
.desc {margin-left:35px;font-size: 16px;font-weight: 400;line-height: 22px;width:285px;}
.desc span {transform: scale(0.83); z-index: 100;position: relative;}
.swiper-button-prev, .swiper-button-next {width: 52px;height: 52px;top: 164px;}
.swiper-button-prev {background: url('../assets/img/homePage/case-left.png') no-repeat;left: -80px;z-index: 100;top:250px;}
.swiper-button-next {background: url('../assets/img/homePage/case-right.png') no-repeat;right: -80px;z-index: 100;top:250px;}
.swiper-button-prev::after, .swiper-button-next::after {display: none;}
.swiper-pagination{width:1100px;height:10px;margin: 10px 10px;}
.swiper-button-prev:hover{background: url('../assets/img/casePage/blue-left-buttom.png') no-repeat;background-size: 100%;}
.swiper-button-next:hover{background: url('../assets/img/casePage/blue-right-button.png') no-repeat;background-size: 100%;}
</style>
<style>
.swiper-pagination .swiper-pagination-bullet{width: 40px;height: 4px; border-radius: 4px;margin: 0 7px;color: #F9FBFE}
.swiper-pagination /deep/ .swiper-pagination-bullet-active{background: #0E5BE0 !important;}
</style>



// WEBPACK FOOTER //
// src/components/CustomCommentSwiper.vue